(function () {
  'use strict';

  angular
    .module('l4b')
    .factory('PageInfoService', PageInfoService);

  PageInfoService.$inject = ['$document', '$window', 'Constants'];

  function PageInfoService($document, $window, Constants) {

    var service = {
      setTitle: setTitle,
      setFavicon: setFavicon,
      setInfoForBrand: setInfoForBrand
    };

    init();

    function init() {
    }

    function setTitle(title) {

      $document[0].title = title || '';
    }

    
function setFavicon(href, type) {
      if (!href) return;

      var doc = $document[0];
      var head = doc.head || doc.getElementsByTagName('head')[0];

      // Build absolute URL to avoid relative-path + <base> surprises
      var a = doc.createElement('a');
      a.href = href; // this will resolve to absolute based on current location
      var absHref = a.href;

      // Cache-bust to force refresh
      var bust = Date.now();
      var finalHref = absHref + (absHref.indexOf('?') >= 0 ? '&' : '?') + 'v=' + bust;

      // Remove all known icon link types (in case one earlier is broken)
      [
        'link[rel="icon"]',
        'link[rel="shortcut icon"]',
        'link[rel="apple-touch-icon"]',
        'link[rel="apple-touch-icon-precomposed"]',
        'link[rel="mask-icon"]'
      ].forEach(function (sel) {
        var existing = head.querySelectorAll(sel);
        Array.prototype.forEach.call(existing, function (node) {
          head.removeChild(node);
        });
      });

      // Create a fresh <link rel="icon"> first (the one most browsers use)
      var link = doc.createElement('link');
      link.setAttribute('rel', 'icon');
      if (type) link.setAttribute('type', type); // 'image/x-icon' or 'image/png'
      link.setAttribute('href', finalHref);
      head.appendChild(link);

      // Add shortcut icon for legacy support
      var legacy = doc.createElement('link');
      legacy.setAttribute('rel', 'shortcut icon');
      if (type) legacy.setAttribute('type', type);
      legacy.setAttribute('href', finalHref);
      head.appendChild(legacy);

      // (Optional) apple-touch-icon if you have one
      // var apple = doc.createElement('link');
      // apple.setAttribute('rel', 'apple-touch-icon');
      // apple.setAttribute('href', finalHref);
      // head.appendChild(apple);
    }


    function setInfoForBrand(brand) {
      if (!brand || !Constants || !Constants.Brand) return;

      var cfg = Constants.Brand[brand];
      if (!cfg) return;

      if (cfg.Description) setTitle(cfg.Description);
      if (cfg.Favicon) setFavicon(cfg.Favicon, null);
    }                                         

    return service;
  }
})();